import { AxiosError } from 'axios';

export function getPostLookupError(error: unknown): string {
  if (error instanceof AxiosError) {
    const status = error.response?.status;
    const data = error.response?.data as { deletedBy?: string } | undefined;

    if (status === 404 && data?.deletedBy) {
      return `This post was deleted by ${data.deletedBy}.`;
    }
    if (status === 404) return 'Post not found';
    if (status === 403) return 'You do not have access to this post';
  }
  return 'Post not found or unavailable';
}
